var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.057 4.907a.75.75 0 01.472.95 1.76 1.76 0 01-.037.099c.158.137.258.34.258.566v13.12c0 1.144-.98 2.106-2.119 2.106H3.191c-1.137 0-2.119-.962-2.119-2.107V7.79c0-1.145.982-2.107 2.12-2.107v1.5c-.323 0-.62.304-.62.607V19.64c0 .303.297.607.62.607H20.63c.323 0 .62-.304.62-.607V7.017c-.046.014-.09.027-.133.038-.482.127-.973.127-1.202.127H3.192v-.75-.75H19.9c.235 0 .554-.004.836-.078.292-.076.353-.173.37-.226a.75.75 0 01.95-.471z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.589 3.715c-.042.035-.099.11-.099.275v2.443a.75.75 0 11-1.5 0V3.99c0-.56.217-1.073.632-1.422.409-.344.941-.474 1.478-.41l15.605 1.538a.747.747 0 01.082.012c.863.184 1.373.663 1.652 1.13a2.354 2.354 0 01.305.858l.003.023v.01l.001.004v.002l-.747.064.747-.063.003.063v.634a.75.75 0 01-1.5 0v-.578a.85.85 0 00-.1-.248c-.083-.14-.25-.331-.638-.423L4.945 3.65l-.019-.002c-.19-.023-.292.029-.337.067z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.839 13.67c0 .35-.286.634-.64.634a.636.636 0 01-.638-.634c0-.35.286-.633.639-.633.353 0 .639.284.639.633z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2 13.787c.054 0 .11-.046.11-.117a.114.114 0 00-.11-.116.114.114 0 00-.111.116c0 .071.056.117.11.117zm-1.39-.117c0-.77.629-1.383 1.39-1.383.76 0 1.389.613 1.389 1.383s-.629 1.384-1.39 1.384c-.76 0-1.388-.613-1.388-1.384z",
    fill: "currentColor"
  })));
}

export default SvgWallet;